export default __webpack_public_path__ + "static/media/party-ashlee.76d83042.jpg";